import { PAGE_ROUTES } from '@/components/nav/utils/url-builders';
import { isPageActive } from '@/lib/is-page-active';
import {
  hydrateCustomers,
  hydrateDeals,
  hydratePayments,
  hydrateTrades,
  hydrateUsers,
  hydrateVehiclesAndListingsFromIndexer,
} from '@/models/hydrate';
import { runInAction } from 'mobx';
import { useEffect } from 'react';

const useDeliveryQueuePageHydrateLatest = () => {
  const isDeliveryQueuePageActive = isPageActive(PAGE_ROUTES.DELIVERY_QUEUE);
  const shouldRun = isDeliveryQueuePageActive;

  useEffect(() => {
    if (!shouldRun) {
      return;
    }

    const hydrateDeliveryQueuePage = async () => {
      // Fetch latest data from API for delivery queue page
      // This ensures eventual consistency with the server
      await Promise.all([
        hydrateDeals(),
        hydrateCustomers(),
        hydrateVehiclesAndListingsFromIndexer(),
        hydrateUsers(),
        hydratePayments(),
        hydrateTrades(),
      ]);
    };

    runInAction(async () => {
      await hydrateDeliveryQueuePage();
    });
  }, [shouldRun]);
};

export default useDeliveryQueuePageHydrateLatest;
